import { render, staticRenderFns } from "./TaggableResponse.vue?vue&type=template&id=2ee62808&scoped=true&"
import script from "./TaggableResponse.vue?vue&type=script&lang=ts&"
export * from "./TaggableResponse.vue?vue&type=script&lang=ts&"
import style0 from "./TaggableResponse.vue?vue&type=style&index=0&id=2ee62808&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee62808",
  null
  
)

export default component.exports